import { createInitials } from 'global/common/dataAdjust'
import React from 'react'
import { Label } from 'semantic-ui-react'
import _ from 'lodash'
import { _standingsViewTypes } from './SectionStandingz'
import { matchFilterHelpers } from '../matches/MatchFilters'

export const TeamLabels = ({ standingsViewType, team, matches, handleMatchClick }) => {

  const lbls_form = (team, teamMatches) => {
    const lbls = _.map(teamMatches, teamMatch => {
      const { display, winner, isSectionMatch, scoreFull, opponentName } = teamMatch
      let color = winner ? 'green' : 'red'
      let title = scoreFull;
      return <Label
        className={isSectionMatch ? 'sm' : ''}
        title={title}
        size='mini'
        color={color}
        onClick={(e) => handleMatchClick && handleMatchClick(e, teamMatch)}>
        {`${opponentName} ${display}`}
      </Label>
    }).reverse()
    return <div className='trs form'>{_.isEmpty(lbls) ? 'None' : lbls}</div>
  }

  const teamDiv_form = () => {
    const tlm = matchFilterHelpers.getLastMatches(matches, team, 5)
    return lbls_form(team, tlm)
  }

  const lbls_remaining = (teamMatches) => {
    const lbls = _.map(teamMatches, teamMatch => {
      const { display, homeMatch, isSectionMatch, prevResult } = teamMatch
      let color = 'grey'
      let cn = isSectionMatch ? 'sm' : null
      let title;
      if (prevResult) {
        cn += prevResult.winner ? ' pw' : ' pl'
        title = prevResult?.scoreFull
      } else {
        cn += ' pn'
      }
      return <Label
        className={cn}
        title={title}
        size='mini'
        color={color}
        onClick={(e) => handleMatchClick(e, teamMatch)}>
        {display}
      </Label>
    }).reverse()
    return <div className='trs remaining' >{_.isEmpty(lbls) ? 'None' : lbls}</div>
  }

  const lbls_insights = (team) => {
    const lbls = []
    const color = 'grey'
    const size = 'mini'
    const { elo, performanceDelta, strengthOfSchedule, winsVsHigherRated } = team?.record?.eloInfo
    lbls.push(<Label title={'ELO'} color={elo >= 1500 ? 'green' : 'red'} size={size}>{`ELO: ${elo}`}</Label>)
    lbls.push(<Label title={'Performance Delta'} color={performanceDelta > 0 ? 'green' : 'red'} size={size}>{`PD: ${performanceDelta}`}</Label>)
    lbls.push(<Label title={'Strength of Schedule'} color={color} size={size}>{`SOS: ${strengthOfSchedule}`}</Label>)
    lbls.push(<Label title={'Wins vs Higher Rated'} color={winsVsHigherRated > 0 ? 'green' : 'red'} size={size}>{`WvsHR: ${winsVsHigherRated}`}</Label>)
    return <div className='trs insights' >{_.isEmpty(lbls) ? 'None' : lbls}</div>
  }

  const lbls_bestWins = (team) => {
    const lbls = []
    const { bestWins } = team?.record?.eloInfo
    if (bestWins) {
      _.forEach(bestWins, w => {
        lbls.push(<Label color='green' size='mini'>{`${createInitials(w.name, 3)} ${w.result}`}</Label>)
      })
    }
    return <div className='trs bestWins'>{_.isEmpty(lbls) ? 'None' : lbls}</div>
  }

  const lbls_worstLosses = (team) => {
    const lbls = []
    const { worstLosses } = team?.record?.eloInfo
    if (worstLosses) {
      _.forEach(worstLosses, w => {
        lbls.push(<Label color='red' size='mini'>{`${createInitials(w.name, 3)} ${w.result}`}</Label>)
      })
    }
    return <div className='trs worstLosses' >{_.isEmpty(lbls) ? 'None' : lbls}</div>
  }

  const lbls_nonSectionWins = (team) => {
    const lbls = []
    const { nonSectionWins } = team?.record?.eloInfo
    if (nonSectionWins) {
      _.forEach(nonSectionWins, w => {
        lbls.push(<Label color='green' size='mini'>{`${createInitials(w.name, 3)} ${w.result}`}</Label>)
      })
    }
    return <div className='trs nonSectionWins'>{_.isEmpty(lbls) ? 'None' : lbls}</div>
  }

  const lbls_nonSectionLosses = (team) => {
    const lbls = []
    const { nonSectionLosses } = team?.record?.eloInfo
    if (nonSectionLosses) {
      _.forEach(nonSectionLosses, w => {
        lbls.push(<Label color='red' size='mini'>{`${createInitials(w.name, 3)} ${w.result}`}</Label>)
      })
    }
    return <div className='trs nonSectionLosses'>{_.isEmpty(lbls) ? 'None' : lbls}</div>
  }

  const lbls_vs = (team) => {
    const lbls = []
    const vsInfo = team?.record?.vsInfo
    const { vs } = vsInfo ?? {}
    if (vs) {
      _.forEach(vs, (v, vk) => {
        const _vk = vk.split('_')
        const l = _vk[0]
        const s = _vk[1].replace('section', '')
        lbls.push(<Label color={v.winPct > 0 ? 'green' : 'red'} size='mini'>{`${l}-${s} #${v.games}/${v.winPct}%`}</Label>)
      })
    }
    return <div className='trs bestWins' >{_.isEmpty(lbls) ? 'None' : lbls}</div>
  }

  const teamDiv_vs = () => lbls_vs(team)
  const teamDiv_bestWins = () => lbls_bestWins(team)
  const teamDiv_worstLosses = () => lbls_worstLosses(team)
  const teamDiv_nonSectionWins = () => lbls_nonSectionWins(team)
  const teamDiv_nonSectionLosses = () => lbls_nonSectionLosses(team)
  const teamDiv_insights = () => lbls_insights(team)
  const teamDiv_remaining = () => {
    const tlm = matchFilterHelpers.getRemainingMatches(matches, team, 5)
    return lbls_remaining(tlm)
  }
  const teamDiv_ns = () => {
    const tlm = matchFilterHelpers.getNonSectionMatches(matches, team)
    return lbls_form(team, tlm)
  }

  switch (standingsViewType) {
    case _standingsViewTypes.bestWins:
      return teamDiv_bestWins()
    case _standingsViewTypes.worstLosses:
      return teamDiv_worstLosses()
    case _standingsViewTypes.nonSectionWins:
      return teamDiv_nonSectionWins()
    case _standingsViewTypes.nonSectionLosses:
      return teamDiv_nonSectionLosses()
    case _standingsViewTypes.form:
      return teamDiv_form()
    case _standingsViewTypes.insights:
      return teamDiv_insights()
    case _standingsViewTypes.remaining:
      return teamDiv_remaining()
    case _standingsViewTypes.vs:
      return teamDiv_vs()
    case _standingsViewTypes.nonSection:
      return teamDiv_ns()
  }

}
